import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import PromotionsList from './PromotionsList';
import {PromotionCRUDActions} from '../../../actions/promotion';
import { setHeaderTitle } from '../../../actions/layout';
import {PROMOTION_ROUTER_EDIT, PROMOTION_ROUTER_NEW} from '../constants';
import {getCurrentClubId} from '../../../selectors/club-settings';
import {listStateFromCRUD, listDispatchFromCrud} from '../../../selectors/crud';

// new way of actions. Has to have less memory in use;
let CRUDActions = new PromotionCRUDActions();
export default connect(
  // map state to props
  (state) =>({
    ...listStateFromCRUD(state.promotion),
    filter: {
      club_id: getCurrentClubId(state)
    }
  }),
  // map dispatch to props
  (dispatch) => ({
    ...listDispatchFromCrud(dispatch, CRUDActions),
    edit: (id) => dispatch(push(PROMOTION_ROUTER_EDIT.replace(':id', id))),
    add: () => dispatch(push(PROMOTION_ROUTER_NEW)),
    updateHeaderTitle: title => dispatch(setHeaderTitle(title)),
  })
)(PromotionsList);



// WEBPACK FOOTER //
// ./src/components/Promotions/PromotionsList/index.js